import { ref } from "vue"

const headerHeight = ref(0)

export const useHeaderHeight = () => ({ headerHeight })
